import { Color } from './Color';

export class CscBrandPalette {
    cscBlueColor = new Color('#003B5C', 0, 59, 92);
    tealColor = new Color('#00B2A9', 0, 178, 169);
    mediumGrayColor = new Color('#97999B', 151, 153, 155);
    hyperlinkBlueColor = new Color('#075A92', 7, 90, 146);
    blackColor = new Color('#222222', 34, 34, 34);
    whiteColor = new Color('#FFFFFF', 255, 255, 255);
    darkGrayColor = new Color('#54585A', 84, 88, 90);
    lightGrayColor = new Color('#D1D3D4', 209, 211, 212);
    coolLightGrayColor = new Color('#EAEBEB', 234, 235, 235);
    coolLightGrayTint1Color = new Color('#F5F5F5', 245, 245, 245);
    darkBlueGrayColor = new Color('#42788F', 66, 120, 143);
    blueGrayColor = new Color('#8DB9CA', 141, 185, 202);
    blueGrayTint1Color = new Color('#D5E5EB', 213, 229, 235);
    blueGrayTint2Color = new Color('#EDF5F7', 237, 245, 247);
    gridHighlightBlueColor = new Color('#EBF6FD', 235, 246, 253);
    greenColor = new Color('#509E2F', 80, 158, 47);
    amaranthColor = new Color('#D1344F', 224, 62, 82);
    goldColor = new Color('#F2A900', 242, 169, 0);
    orangeColor = new Color('#F68D2E', 246, 141, 46);
    flatPrimaryButtonHoverColor = new Color('#1E5879', 30, 88, 121);
    overlayLightColor = new Color('#FFFFFFBF', 255, 255, 255, 0.75);
    overlayDarkColor = new Color('#00000066', 0, 0, 0, 0.4);

    get cscBlue() {
        return this.cscBlueColor.toString();
    }
    get teal() {
        return this.tealColor.toString();
    }
    get mediumGray() {
        return this.mediumGrayColor.toString();
    }
    get hyperlinkBlue() {
        return this.hyperlinkBlueColor.toString();
    }
    get black() {
        return this.blackColor.toString();
    }
    get white() {
        return this.whiteColor.toString();
    }
    get darkGray() {
        return this.darkGrayColor.toString();
    }
    get lightGray() {
        return this.lightGrayColor.toString();
    }
    get coolLightGray() {
        return this.coolLightGrayColor.toString();
    }
    get coolLightGrayTint1() {
        return this.coolLightGrayTint1Color.toString();
    }
    get darkBlueGray() {
        return this.darkBlueGrayColor.toString();
    }
    get blueGray() {
        return this.blueGrayColor.toString();
    }
    get blueGrayTint1() {
        return this.blueGrayTint1Color.toString();
    }
    get blueGrayTint2() {
        return this.blueGrayTint2Color.toString();
    }
    get gridHighlightBlue() {
        return this.gridHighlightBlueColor.toString();
    }
    get green() {
        return this.greenColor.toString();
    }
    get amaranth() {
        return this.amaranthColor.toString();
    }
    get gold() {
        return this.goldColor.toString();
    }
    get orange() {
        return this.orangeColor.toString();
    }
    get flatPrimaryButtonHover() {
        return this.flatPrimaryButtonHoverColor.toString();
    }
    get overlayLight() {
        return this.overlayLightColor.toString();
    }
    get overlayDark() {
        return this.overlayDarkColor.toString();
    }
}
